<template>
  <div>
    <div class="tabs">
      <ul>
        <router-link tag="li" to="/system" active-class="is-active" exact>
          <a>System settings</a>
        </router-link>
        <router-link tag="li" to="/system/currencies" active-class="is-active">
          <a>Currencies</a>
        </router-link>
        <router-link tag="li" to="/system/ps" active-class="is-active">
          <a>Payment system</a>
        </router-link>
      </ul>
    </div>

    <div>
      <router-view/>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'system'
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/system/index.vue